// 合同记录
import { i18n } from '@/common/utils/i18n'
import ContractType from '@/pages/shopDetail/config/ContractType'
import { get } from 'lodash-es'

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('合同记录'),
    content: [
      {
        title: i18n.gettext('合同类型'),
        content: ContractType.val2text(contractInfo.contractType)
      },
      {
        title: i18n.gettext('合同编号'),
        label: contractInfo.contractId
      },
      {
        title: i18n.gettext('合同记录'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        alert: i18n.gettext('请在Gattaran查看')
      }
    ]
  }
}
